import {createApp} from 'vue'
import {defineAsyncComponent} from 'vue'

const appObject = {
	components:{
		eventsMain: defineAsyncComponent({
			loader: () => import('./components/Widgets/EventsMain.vue')
		}),
	},
	data(){
		return {

		}
	},
	computed:{

	},
	mounted(){

	},
	methods:{
		checkSelectValidity( el )
		{
			if(!el.value)
			{
				el.classList.add("error");
				el.classList.add("default-input__input--error");
				return false;
			}
			else
			{
				el.classList.remove("error");
				el.classList.remove("default-input__input--error");
				return true;
			}
		},

		checkValidity( el )
		{

			if(!el.checkValidity())
			{
				el.classList.add("error");
				el.classList.add("default-input__input--error");
				//input.parentElement.querySelector('.default-input__error').innerHTML='Обязательное поле';
				return false;
			}
			else
			{
				if(el.type === "file")
				{

					let fileInput = el;
					if(fileInput && fileInput.files.length && fileInput.files[0])
					{
						Array.from(fileInput.files).forEach(( file ) =>
							{
								if(file.size > 5 * 1024 * 1024)
								{
									// alert("Размер файла более 5 Мб.");
									// fileInput.closest('div').getElementsByClassName('default-file__placeholder')[0].textContent = '';
									// fileInput.value = "";
									el.classList.add("error");
									el.classList.add("default-input__input--error");
									return false;
								}

								let allowExp = [
									"jpg",
									"pdf",
									"png"
								];

								let parts = file.name.split(".");
								if(!allowExp.includes(parts.pop()))
								{
									// alert("Формат документа \"" + parts.pop() + "\" не соответствует возможному для загрузки");
									// fileInput.closest('div').getElementsByClassName('default-file__placeholder')[0].textContent = '';
									// fileInput.value = "";
									el.classList.add("error");
									el.classList.add("default-input__input--error");
									return false;
								}
								el.classList.remove("error");
								el.classList.remove("default-input__input--error");
							}
						);
					}

				}
				else if(el.classList.contains("mask--phone"))
				{

					let phone = (el.value).replace(/[_()\-+ ]/gim, "");
					if(phone.length !== 11)
					{
						el.classList.add("error");
						el.classList.add("default-input__input--error");
						return false;
					}
					else
					{
						el.classList.remove("error");
						el.classList.remove("default-input__input--error");
					}
				}
				else if(el.classList.contains("mask--email"))
				{
					let emailRegexp = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

					let isValidEmail = emailRegexp.test(el.value);
					if(!isValidEmail)
					{
						el.classList.add("error");
						el.classList.add("default-input__input--error");
						return false;
					}
					else
					{
						el.classList.remove("error");
						el.classList.remove("default-input__input--error");
					}
				}
				else if(el.classList.contains("input__inn"))
				{

					let inn  = (el.value).replace(/[_()\-+ ]/gim, "");
					el.value = inn.substring(0, 12);
					inn      = el.value;
					if(inn.length !== 10 && inn.length !== 12)
					{
						el.classList.add("error");
						el.classList.add("default-input__input--error");
						return false;
					}
				}
				else
				{
					el.classList.remove("error");
					el.classList.remove("default-input__input--error");
				}
			}
			return true;
		},

		removeErrorClass( el )
		{
			el.classList.add("no-error");
			el.classList.remove("error");
			el.classList.remove("default-input__input--error");
		},

		checkForm()
		{

			let form = event.target.closest("form");

			let required        = form.querySelectorAll("input[required],textarea[required]");
			let requiredSelects = form.querySelectorAll("select[required]");
			let allow           = true;

			Array.from(required).forEach(input =>
			{
				if(this.checkValidity(input) !== true)
				{
					allow = false;
				}
			});

			Array.from(requiredSelects).forEach(select =>
			{
				if(!this.checkSelectValidity(select))
				{
					allow = false;
				}
			});

			if(!allow)
			{
				event.preventDefault();
				return false;
			}

			return true;
		},
	},
};
const app = createApp(appObject)

app.mount('#portal-vue')

